"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const BaseApi_1 = __importDefault(require("./BaseApi"));
class ProductApi extends BaseApi_1.default {
    list(filters) {
        var _a;
        return this.http.get("/shop/api/v1/products/", {
            params: Object.assign(Object.assign({}, filters), { types: (_a = filters === null || filters === void 0 ? void 0 : filters.types) === null || _a === void 0 ? void 0 : _a.join(",") }),
        });
    }
}
exports.default = ProductApi;
